import { useState } from 'react';

import { SelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useReportError } from '@/hooks/useReportError';
import { getNodes } from '@/utils/graphqlUtils';

import { useGetTransferGiftTypeOptionsQuery } from '../graphql/GetTransferGiftTypeOptions.generated';

const formInitErrorMessage =
  "We weren't able to initialize this form. Please refresh the page and try again.";

export function useTransferGiftTypeOptions(waterfallId: string) {
  const { createErrorFeedback, showFeedback } = useFeedback();
  const { reportError } = useReportError();

  const [typeOptions, setTypeOptions] = useState<SelectInputOption<string>[]>(
    []
  );

  const queryMethods = useGetTransferGiftTypeOptionsQuery({
    variables: {
      where: {
        id: waterfallId,
      },
    },
    onCompleted(data) {
      const waterfalls = getNodes(data.estateWaterfalls);

      const grantors = waterfalls[0]?.household?.possiblePrimaryClients;

      if (!grantors) {
        const errorDescription = 'Expected grantors for the waterfall.';
        const err = new Error(errorDescription);
        reportError(errorDescription, err, {
          waterfallId,
        });
        showFeedback(formInitErrorMessage);
        return;
      }

      setTypeOptions(
        grantors.map((grantor) => ({
          display: grantor.displayName,
          value: grantor.id,
        })) ?? []
      );
    },
    onError: createErrorFeedback(formInitErrorMessage),
  });

  return { typeOptions, ...queryMethods };
}
